import { render, staticRenderFns } from "./SuccessfulUnsubscribe.vue?vue&type=template&id=52cb9f32"
import script from "./SuccessfulUnsubscribe.vue?vue&type=script&lang=js"
export * from "./SuccessfulUnsubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports